/**
 * TanStack Router: /workforce/roles/new
 *
 * Create new role form
 * Layout: Authenticated (_auth)
 *
 * @see src/app/workforce/roles/new/page.tsx
 */
import { createFileRoute } from '@tanstack/react-router'
import NewRolePage from '@/app/workforce/roles/new/page'

/**
 * Route: /workforce/roles/new
 * Layout: _auth (authenticated)
 * Component: NewRolePage
 */
export const Route = createFileRoute('/_auth/workforce/roles/new')({
  component: NewRolePage,
})
